import { Badge, Typography } from '@material-ui/core'
import { ChatBubble } from '@material-ui/icons'
import React, { memo, useMemo, useState, useCallback } from 'react'

import FullWidthTabs from '../../../../UI/Tabs/Tabs'

import FeedbackStructure from './FeedbackStructure/FeedbackStructure'

const FeedbackBox = ({
  availableStructures,
  onItemExpanded,
  chatHistory,
  onFeedbackSubmit,
  onFeedbackFileClick,
  onFeedbackScroll,
  chatLoading,
  chatInputLoading,
  isAdmin
}) => {
  const [currentTabIndex, setCurrentTabIndex] = useState(0)

  const onTabChangedHandler = useCallback((e, newIndex) => {
    setCurrentTabIndex(newIndex)
  }, [])

  const { tabs, tabContents } = useMemo(() => {
    let tabs = []
    let tabContents = []
    availableStructures.forEach((struct, index) => {
      const shouldShowIcon = struct.items.some(item => !!item.is_unread)
      const tabKey = `${struct.structure_id}-${index}`

      let label = struct.structure_name
      if (shouldShowIcon) {
        label = (
          <>
            <Badge color={'error'} variant={'dot'}>
              <Typography variant={'body2'}>{label}</Typography>
              <ChatBubble fontSize={'small'} />
            </Badge>
          </>
        )
      }

      const tab = { key: tabKey, label }
      const content = { display: <></>, key: tabKey, style: { padding: 0 } }

      tabContents = [...tabContents, content]
      tabs = [...tabs, tab]
    })

    return { tabs, tabContents }
  }, [availableStructures])

  return (
    <>
      <FullWidthTabs
        variant={'scrollable'}
        scrollButtons={'auto'}
        tabs={tabs}
        tabContents={tabContents}
        currentTabIndex={currentTabIndex}
        tabChanged={onTabChangedHandler}
      />
      <FeedbackStructure
        items={availableStructures[currentTabIndex]?.items ?? []}
        history={chatHistory}
        onItemExpanded={onItemExpanded}
        onFeedbackSubmit={onFeedbackSubmit}
        onFeedbackFileClick={onFeedbackFileClick}
        onFeedbackScroll={onFeedbackScroll}
        chatLoading={chatLoading}
        chatInputLoading={chatInputLoading}
        currentTabIndex={currentTabIndex}
        isAdmin={isAdmin}
      />
    </>
  )
}

export default memo(FeedbackBox)
